import { NavLink, Navigate, useParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SECTIONS } from "@/components/shell/nav";
import { EnTete } from "@/components/commun";
import Compte from "@/pages/parametres/Compte";
import Utilisateurs from "@/pages/parametres/Utilisateurs";
import Partenaires from "@/pages/parametres/Partenaires";
import Connexions from "@/pages/parametres/Connexions";
import Corbeille from "@/pages/parametres/Corbeille";
import Journal from "@/pages/parametres/Journal";
import Emails from "@/pages/parametres/Emails";
import Sauvegardes from "@/pages/parametres/Sauvegardes";
import Themes from "@/pages/parametres/Themes";
import Processus from "@/pages/parametres/Processus";
import Champs from "@/pages/parametres/Champs";
import Vues from "@/pages/parametres/Vues";
import Reserves from "@/pages/parametres/Reserves";
import Statuts from "@/pages/parametres/Statuts";
import EntreesLeads from "@/pages/parametres/EntreesLeads";
import Pieces from "@/pages/parametres/Pieces";
import Modeles from "@/pages/parametres/Modeles";
import ModeleDevis from "@/pages/parametres/ModeleDevis";
import ReglesAutomatisation from "@/pages/parametres/ReglesAutomatisation";
import ReglagesIA from "@/pages/parametres/ReglagesIA";
import Scripts from "@/pages/parametres/Scripts";
import Commissions from "@/pages/parametres/Commissions";
import MigrationNocrm from "@/pages/parametres/MigrationNocrm";
import Partage from "@/pages/parametres/Partage";

const COMPOSANTS = { compte: Compte, utilisateurs: Utilisateurs, partenaires: Partenaires, processus: Processus, champs: Champs, connexions: Connexions, corbeille: Corbeille, journal: Journal, emails: Emails, sauvegardes: Sauvegardes, themes: Themes, vues: Vues, reserves: Reserves, statuts: Statuts, leads: EntreesLeads, pieces: Pieces, modeles: Modeles, modeles_devis: ModeleDevis, regles_automatisation: ReglesAutomatisation, commissions: Commissions, ia: ReglagesIA, scripts: Scripts, migration_nocrm: MigrationNocrm, partage: Partage };

export default function Parametres() {
  const { section } = useParams();
  const { user } = useAuth();
  const sections = user.navigation.parametres;
  if (!sections.includes(section)) return <Navigate to="/parametres/compte" replace />;
  const Composant = COMPOSANTS[section];
  return (
    <div data-testid="page-parametres">
      <EnTete titre="Paramètres" />
      <div className="md:grid md:grid-cols-[220px_1fr] gap-6">
        <nav className="overflow-x-auto no-scrollbar -mx-4 px-4 md:mx-0 md:px-0 mb-5 md:mb-0">
          <div className="flex md:flex-col gap-2 w-max md:w-auto">
            {sections.map((s) => (
              <NavLink key={s} to={`/parametres/${s}`} data-testid={`settings-nav-${s}`}
                className="min-h-[44px] px-4 flex items-center at-pill font-semibold whitespace-nowrap transition-colors duration-200"
                style={({ isActive }) => ({ background: isActive ? "var(--accent)" : "var(--surface)", color: isActive ? "var(--accent-ink)" : "var(--ink)" })}>
                {SECTIONS[s]}
              </NavLink>
            ))}
          </div>
        </nav>
        <section className="min-w-0" data-testid={`settings-section-${section}`}><Composant /></section>
      </div>
    </div>
  );
}
